<template>
  <div class="page-shell">
    <div>
      <div class="page-header">
        <div class="page-header__titles">
          <h1 class="page-title">Leave Credits and Employee Profile</h1>
          <p class="page-subtitle">
            Track vacation and sick leave balances per employee
          </p>
        </div>
        <div class="page-actions">
          <v-btn color="primary" outlined>
            <v-icon left small>mdi-refresh</v-icon>
            Generate VL and SL
          </v-btn>
        </div>
      </div>
      <div class="content-card">
        <v-text-field
          label="Search employees"
          v-model="search"
          outlined
          dense
          clearable
          prepend-inner-icon="mdi-magnify"
          hide-details
          class="mb-4"
        ></v-text-field>
        <v-data-table :items="employees" :headers="headers" :search="search">
          <template v-slot:item.actions="{ item }">
            <v-btn color="primary" @click="openModal(item)" icon small>
              <v-icon small>mdi-list-box-outline</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.balance="{ item }">
            {{
              (item.vl_balance ? item.vl_balance : 0) +
              (item.sl_balance ? item.sl_balance : 0)
            }}
          </template>
          <template v-slot:no-data>
            <v-alert :value="true" color="error" icon="mdi-alert" text dense>
              Sorry, nothing to display.
            </v-alert>
          </template>
        </v-data-table>
      </div>
    </div>
    <!-- lazy loaded components -->
    <view-leave-credits-modal
      v-if="showViewLeaveCreditsModal"
      :item="selectedItem"
      @close="showViewLeaveCreditsModal = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    ViewLeaveCreditsModal: () =>
      import("@/components/LeaveCredit/viewLeaveCreditsModal.vue"),
  },
  data() {
    return {
      showViewLeaveCreditsModal: false,
      selectedItem: {},
      search: "",
      headers: [
        { text: " Actions", value: "actions", sortable: false },
        { text: "ID", value: "id" },
        { text: "Full Name", value: "name" },
        { text: "Department", value: "department.department_name" },
        { text: "Employment Status", value: "employment_status" },
        { text: "VL Credits", value: "vl_balance" },
        { text: "SL Credits", value: "sl_balance" },
        { text: "Balance", value: "balance" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      employees: "employee/employees",
    }),
  },
  methods: {
    ...mapActions({
      get_employees: "employee/get_employees",
    }),
    openModal(item) {
      // console.log(this.selectedItem);
      this.selectedItem = item;
      this.showViewLeaveCreditsModal = true;
    },
  },
  created() {
    if (this.employees.length === 0) {
      this.get_employees();
    }
    console.log(this.employees);
  },
};
</script>

<style></style>
